import Cookies from 'js-cookie'
import { useState } from 'react'

const COOKIE_BANNER_DISMISSED_KEY = 'cookie-banner-dismissed'
const COOKIE_BANNER_DISMISSED_EXPIRY_DAYS = 90

interface UseCookieBannerResult {
  showCookieBanner: boolean
  dismissCookieBanner: () => void
}

export const useCookieBanner = (): UseCookieBannerResult => {
  const [showCookieBanner, setShowCookieBanner] = useState(
    !Cookies.get()[COOKIE_BANNER_DISMISSED_KEY],
  )

  const dismissCookieBanner = () => {
    setShowCookieBanner(false)
    Cookies.set(COOKIE_BANNER_DISMISSED_KEY, true, {
      expires: COOKIE_BANNER_DISMISSED_EXPIRY_DAYS,
    })
  }

  return { showCookieBanner, dismissCookieBanner }
}
